<template>
    <div>
        <v-expand-transition>
            <div>
                <div v-for="tabulation in tabulations">
                    <component :index="tabulation.index"
                               :is="tabulation.component"
                               :uska-form="uskaForm"
                               :new-title="tabulation.new_title"
                               :help-desc="tabulation.help_description"
                               v-if="tabulation.component !== null">
                    </component>
                </div>
            </div>
        </v-expand-transition>
    </div>
</template>

<script>
import General from "./tabulations/General"
import Handicapped from "./tabulations/Handicapped"
import Localisation from "./tabulations/Localisation"
import Contacts from "./tabulations/Contacts"
import Extra from "./tabulations/Extra"
import Covid from "./tabulations/Covid"
import Medias from "./tabulations/Medias"
import Capacities from "./tabulations/Capacities"
import Specific from "./tabulations/Specific"
import RoomRenting from "./tabulations/RoomRenting"
import OpeningHours from "./tabulations/OpeningHours"
import PricePeriods from "./tabulations/PricePeriods"
import Platform from "./tabulations/Platform"
import ApidaeContacts from "./tabulations/ApidaeContacts";
import PrivateDescriptifs from "./tabulations/PrivateDescriptifs.vue"
import CmajFormMenu from "./CmajFormMenu.vue"
import {mapState, mapGetters, mapMutations} from "vuex"

export default {
    name: "CmajFormTabulations",
    props: ['tabulations'],
    components: {
        PrivateDescriptifs,
        ApidaeContacts,
        Platform,
        CmajFormMenu,
        PricePeriods,
        OpeningHours,
        RoomRenting,
        Specific,
        Capacities,
        Medias,
        Covid,
        Extra,
        Contacts,
        Localisation,
        General,
        Handicapped
    },
    computed: {
        ...mapState('web_form', ['origin']),
        uskaForm() {
            return this.origin === 'USKA'
        }
    }
}
</script>

